
import {throwError as observableThrowError, Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {catchError} from 'rxjs/operators';
import {TaxplanIQServices} from "../services/TaxplanIQServices";
import {SOURCE_TYPE} from "../constants/Tpiq.constants";


export function getDropdownList(userId, org) {
    return `/TaxPlanningServices/orgs/${org}/users/${userId}/questionnaires/dropdowns`;
}

export function getPaginatedOrganizers(userId, org) {
    return `/TaxPlanningServices/orgs/${org}/users/${userId}/questionnaires/filters`;
}

export function getOrganizersCountUrl(userId, org) {
    return `/TaxPlanningServices/orgs/${org}/users/${userId}/questionnaires/statusCount`;
}

/** Build the editable status endpoint. The separate Mark Done endpoint ignores the selected status. */
export function updateRowStatus(org, userId, clientId, questionnaireId) {
    return `/TaxPlanningServices/orgs/${org}/users/${userId}/channels/clients/${clientId}/questionnaires/${questionnaireId}/status`;
}

@Injectable({
    providedIn: "root"
})
export class OrganizersService extends  TaxplanIQServices {
    options = {};
    constructor(http: HttpClient) {
        super(http);
    }

    getDropdownLists(userId, org): Observable<any> {
        const url = getDropdownList(userId, org);
        return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
    }

    getPaginatedOrganizersList(userId, org, filters): Observable<any> {
        const url = getPaginatedOrganizers(userId, org);
        return this.create(url, filters, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
    }

    getOrganizersCount(userId, org, filters): Observable<any> {
        const url = getOrganizersCountUrl(userId, org);
        return this.create(url, filters, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
    }

    /** Save the selected status through the organizer table endpoint. */
    updateOnTable(org, userId, clientId, questionnaireId, request): Observable<any> {
        const url = updateRowStatus(org, userId, clientId, questionnaireId);
        return this.patch(url, request, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
    }

   private handleError(error: HttpErrorResponse) {
    return observableThrowError(error.error);
  }
}
